import React from 'react';
import PropTypes from 'prop-types';
import s from './SetpointsList.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Table from 'react-bootstrap/Table';
import MoreOption from '../WSAControls/MoreOption/MoreOption';
import { v4 as uuidv4 } from 'uuid';
import { FLOWSEQUENCE_TYPE, SERVICE_TYPE, SETPOINTS_TYPE } from '../../constants';

const SetpointsListTable = ({
  ModelCategoryId,
  paginatedData = [],
  changeAllowed,
  deleteAllowed,
  duplicateAllowed,
  onDeleteClick,
  isModelCategoryOwner
}) => {
  const getMoreOptions = setpointId => {
    let options = [];
    if (changeAllowed && isModelCategoryOwner) {
      options.push({
        Url: `/operational-setup/model-category-configuration/${ModelCategoryId}/setpoints/${setpointId}`,
        Name: <FormattedMessage id="common.ledit" defaultMessage="Edit" />
      });
    }

    if (duplicateAllowed && isModelCategoryOwner) {
      options.push({
        Url: `/operational-setup/model-category-configuration/${ModelCategoryId}/setpoints/${setpointId}?duplicate=1`,
        Name: <FormattedMessage id="setpointsManagement.duplicate" defaultMessage="Duplicate" />
      });
    }

    if (deleteAllowed && isModelCategoryOwner) {
      options.push({
        Name: <FormattedMessage id="setpointsManagement.remove" defaultMessage="Remove" />,
        Click: () => {
          onDeleteClick(setpointId);
        }
      });
    }

    return options;
  };

  const getSetpointsType = type => {
    let returnType = <FormattedMessage id="setpointsManagement.flowSequence" defaultMessage="Flow Sequence" />;
    switch (type) {
      case FLOWSEQUENCE_TYPE:
        returnType = <FormattedMessage id="setpointsManagement.flowSequence" defaultMessage="Flow Sequence" />;
        break;
      case SETPOINTS_TYPE:
        returnType = <FormattedMessage id="setpointsManagement.setpoint" defaultMessage="Setpoint" />;
        break;
      case SERVICE_TYPE:
        returnType = <FormattedMessage id="setpointsManagement.serviceType" defaultMessage="Service Type" />;
        break;
      default:
        break;
    }

    return returnType;
  };

  return (
    <div className={s.wsTableContainer}>
      <Table variant className={s.wsTable}>
        <thead>
          <tr>
            <th>
              <FormattedMessage id="setpointsManagement.setpointGroupName" defaultMessage="Setpoint Group" />
            </th>
            <th>
              <FormattedMessage id="setpointsManagement.name" defaultMessage="Name" />
            </th>
            <th>
              <FormattedMessage id="setpointsManagement.type" defaultMessage="type" />
            </th>
            <th>
              <FormattedMessage id="setpointsManagement.code" defaultMessage="Code" />
            </th>
            <th className="d-none d-md-table-cell">
              <FormattedMessage id="setpointsManagement.defaultValue" defaultMessage="Default Value" />
            </th>
            {(changeAllowed || deleteAllowed || duplicateAllowed) && <th></th>}
          </tr>
        </thead>
        <tbody>
          {paginatedData.map(n => {
            return (
              <tr key={n.SetpointId} data-unittest="setpointsData">
                <td>{n.SetpointGroup || ''}</td>
                <td>{n.Name || ''}</td>
                <td>{getSetpointsType(n.Type)}</td>

                <td>{n.Code || ''}</td>
                <td className="d-none d-md-table-cell">{n.DefaultValue || ''}</td>
                <td>
                  <div className={s.moreOtions}>
                    {isModelCategoryOwner && (changeAllowed || deleteAllowed || duplicateAllowed) && (
                      <MoreOption key={uuidv4()} dataArray={getMoreOptions(n.SetpointId)} />
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};


SetpointsListTable.propTypes = {
  currentTimezone: PropTypes.string.isRequired
};

export default injectIntl(SetpointsListTable);
